import React from "react";
import { Navigate, useLocation, useNavigate } from "react-router-dom";
import { getTokenToLocalStorage } from "@/utils/token";
import { getUserPermissions } from "@/components/business/RolePermission";
import { Button, Message, Result } from "@arco-design/web-react";
import { coming_soon_icon } from "@/assets/user-center";
import { Permissions } from "@/components/business/RolePermission/permissions";
import User from "@/stores/userStore";
import Login from "@/stores/login";
import { observer } from "mobx-react";

const RedirectRoute = ({ children }) => {
  const token = getTokenToLocalStorage();
  const location = useLocation();

  const searchParams = new URLSearchParams(location.search);
  const next = searchParams.get("next") || "";

  const routerArr = [
    {
      path: "/account-management",
      key: '1', // 账号管理
    },
    {
      path: "/customer-management",
      key: '2', // 客户管理
    },
    {
      path: "/customer-protection",
      key: '3', // 客户保护
    },
    {
      path: "/account-auth",
      key: '4' // 账号授权
    },
    {
      path: "/financial-statement",
      key: '6', // 财务流水
    },
    {
      path: "/case-query",
      key: '7',
    },
    {
      path: "/service/message",
      key: '8-1',
    },
    {
      path: "/service/comment",
      key: '8-2',
    },
  ];

  // 如果存在token，并且用户不是超级管理员（role_id !== 1）
  if (token && !next && Login?.user_info?.role_id !== 1) {
    // 查找当前路由
    const currentRoute = routerArr.find(item => location.pathname.startsWith(item.path));

    if (currentRoute) {
      // 检查当前路由是否有权限
      const hasPermission = getUserPermissions(currentRoute.key);

      if (!hasPermission) {
        // 尝试找到下一个有权限的路由
        for (let i = 0; i < routerArr.length; i++) {
          const route = routerArr[i];
          if (getUserPermissions(route.key)) {
            // 跳转到下一个有权限的路由
            Message.error("您没有访问该页面的权限，请联系管理员");
            return <Navigate to={route.path} />;
          }
        }

        // 如果没有任何路由有权限，显示403页面
        return (
          <Result
            style={{
              width: '100vw',
              height: '100vh',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              flexDirection: 'column',
            }}
            status="403"
            subTitle="您暂无权限"
          />
        );
      }
    }
  }

  // 如果存在token且用户有权限，则渲染子组件
  return children;
};

export default observer(RedirectRoute);
